var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M0 7h20.09m0 0c-2.068 0-6.5-1.3-6.5-6.5m6.5 6.5c-2.068 0-6.5 1.3-6.5 6.5"
  })));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyMSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNi45OTk3MUgyMC4wOU0yMC4wOSA2Ljk5OTcxQzE4LjAyMTkgNi45OTk3MSAxMy41OTAzIDUuNjk5NzcgMTMuNTkwMyAwLjVNMjAuMDkgNi45OTk3MUMxOC4wMjE5IDYuOTk5NzEgMTMuNTkwMyA4LjMwMDIzIDEzLjU5MDMgMTMuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";